module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "a3d"
  }, [_c('div', {
    staticClass: "nav-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dash'
      }
    }
  }, [_c('img', {
    staticClass: "a3d logo",
    attrs: {
      "src": "/static/img/siemens_logo_white.svg"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "hide-on-med-and-down a3d bold",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "nav-mobile"
    }
  }, [_c('li', [_c('a', {
    staticClass: "menu-link",
    on: {
      "click": function($event) {
        return _vm.auth.logout()
      }
    }
  }, [_vm._v("Logout")])])])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('div', {
    staticClass: "field-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.isGovcloudUser),
      expression: "form.isGovcloudUser"
    }],
    staticClass: "filled-in",
    attrs: {
      "type": "checkbox",
      "id": "isGovcloudUser"
    },
    domProps: {
      "checked": _vm.form.isGovcloudUser,
      "checked": Array.isArray(_vm.form.isGovcloudUser) ? _vm._i(_vm.form.isGovcloudUser, null) > -1 : (_vm.form.isGovcloudUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.isGovcloudUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "isGovcloudUser", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "isGovcloudUser", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "isGovcloudUser", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "isGovcloudUser"
    }
  }, [_vm._v("My data needs to be kept in a government restricted zone due to it being covered by regulations such as ITAR.")])])]), _vm._v(" "), _c('div', {
    staticClass: "center-align"
  }, [_c('button', {
    staticClass: "a3d btn",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-align"
  }, [_c('h4', {
    staticClass: "onboard-title"
  }, [_vm._v("Please finish configuring your account")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-79d2a423", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79d2a423"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Onboard.vue
// module id = 489
// module chunks = 1